///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, inject } from '@angular/core';
import { AbstractDialogManager } from '../../../dialog-manager/abstract-dialog-manager';
import { UserDialogComponent } from './user-dialog.component';
import { UserService } from '../../service/user.service';
import { Observable } from 'rxjs';
import { SuiUserDTO } from '../../../generated/shared-sui-types.model';

@Component({
    template: '',
    standalone: false
})
export class EditUserDialogWrapperComponent extends AbstractDialogManager<SuiUserDTO, UserDialogComponent> {
    private readonly userService = inject(UserService);

    constructor() {
        super(UserDialogComponent);
        this.openDialog();
    }

    preparingBaseConfig(): void {
        this.baseConfig.width = '800px';
        this.baseConfig.position = { top: '30px' };
        this.baseConfig.data.id = +this.activatedRoute.snapshot.paramMap.get('id') || null;
    }

    override findById(id: number): Observable<SuiUserDTO> {
        return this.userService.findById(id);
    }
}
